"use client";

import React, { useContext, useEffect, useState } from "react";
import logo from "../../assets/images/main-logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./layout.css";
import loaderContext from "../../context/LoaderContext";

export default function Sidebar({ activeItem }) {
  const navigate = useNavigate();
  const loginUser = JSON.parse(localStorage.getItem("user"));
  const cleaningType = localStorage.getItem("cleaning_type")?.replace(/"/g, "");

  const [loginUserType, setLoginUserType] = useState("");
  const { selectedMenu, setSelectedMenu, activeDD, setActiveDD } =
    useContext(loaderContext);

  let addBodyClass = () => {
    let w = window.innerWidth;
    if (w < 1200) {
      document?.body?.classList?.toggle("resize-menu");
    }
  };

  let onClickaddBodyClass = () => {
    let w = window.innerWidth;
    if (w < 1200) {
      document?.body?.classList?.toggle("resize-menu");
      return;
    }
    document.body.classList.add("resize-menu");
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      navigate("/login");
    } else {
      setLoginUserType(loginUser?.user_type);

      // Handle cleaning_type logic
      if (cleaningType === null) {
        // Super admin panel - can access both portals
        // Check for education portal persistence
        const educationPortalActive = localStorage.getItem(
          "educationPortalActive"
        );
        if (educationPortalActive === "true") {
          setSelectedMenu("education");
        } else {
          setSelectedMenu("bus"); // Default to bus portal
          localStorage.setItem("selectedMenu", "bus");
        }
      } else if (cleaningType === "College Cleaning") {
        // Education portal
        setSelectedMenu("education");
        localStorage.setItem("selectedMenu", "education");
      } else {
        // Bus portal for all other cleaning types
        setSelectedMenu("bus");
        localStorage.setItem("selectedMenu", "bus");
      }
    }
  }, []);

  return (
    <>
      <div className="dash-menu">
        <div className="dashbord-logo">
          <Link role="button" className="navbar-brand">
            <img src={logo} alt="Logo" />
          </Link>
          <Link
            role="button"
            className="toggle cross-icon"
            onClick={onClickaddBodyClass}
          >
            <i className="fa fa-chevron-left" />
          </Link>
        </div>

        {(loginUserType === "SUPER_ADMIN" ||
          loginUserType === "ADMIN_MANAGER" ||
          loginUserType === "CLEANING_MANAGER" ||
          loginUserType === "CLIENT") && (
          <>
            {loginUserType === "SUPER_ADMIN" && (
              <div className="portal w-full d-flex flex-column justify-content-center align-items-center">
                <div
                  className="dropdown-menu-btn"
                  onClick={() => setActiveDD(!activeDD)}
                >
                  {selectedMenu === "bus" ? (
                    <span className="fa fa-bus me-2 icon" />
                  ) : (
                    <span className="fa fa-graduation-cap me-2 icon" />
                  )}
                  {selectedMenu === "bus" ? "Bus Portal" : "Education Portal"}
                </div>
                <div
                  className={
                    activeDD ? "dropdown-menu-dm dm-active" : "dropdown-menu-dm"
                  }
                >
                  <div
                    className="dropdown-menu-item"
                    onClick={() => {
                      localStorage.setItem("selectedMenu", "bus");
                      localStorage.removeItem("educationPortalActive");
                      setSelectedMenu("bus");
                      setActiveDD(false);
                      navigate("/");
                    }}
                  >
                    <span className="fa fa-bus me-2 icon" /> Bus Portal
                  </div>
                  <div
                    className="dropdown-menu-item"
                    onClick={() => {
                      localStorage.setItem("selectedMenu", "education");
                      localStorage.setItem("educationPortalActive", "true");
                      setSelectedMenu("education");
                      setActiveDD(false);
                      navigate("/education");
                    }}
                  >
                    <span className="fa fa-graduation-cap me-2 icon" />{" "}
                    Education Portal
                  </div>
                </div>
              </div>
            )}

            {selectedMenu === "bus" &&
              (loginUserType === "SUPER_ADMIN" ||
                ((loginUserType === "ADMIN_MANAGER" ||
                  loginUserType === "CLEANING_MANAGER" ||
                  loginUserType === "CLIENT") &&
                  cleaningType !== "College Cleaning")) && (
                <div className="dash-menu-bar">
                  <nav
                    className="nav-menu navbar navbar-expand-lg d-flex flex-column justify-content-center"
                    id="navbar"
                  >
                    <ul>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-th-large me-2 icon" />
                          Dashboard
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/analytics"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-line-chart me-2 icon" />{" "}
                          Analytics
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/user-List"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-users me-2 icon" /> Users
                        </NavLink>
                      </li>
                      <li className="nav-item " onClick={addBodyClass}>
                        <NavLink
                          to="/bus-list"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-bus me-2 icon " /> Bus
                          Management
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/report-list"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-flag me-2 icon" /> Report
                          Management
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/depo-list"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-bus me-2 icon" /> Depot
                          Management
                        </NavLink>
                      </li>
                      {loginUserType === "SUPER_ADMIN" && (
                        <li className="nav-item" onClick={addBodyClass}>
                          <NavLink
                            to="/company-list"
                            className={({ isActive }) =>
                              isActive ? "nav-link active" : "nav-link"
                            }
                          >
                            <span className="fa fa-building me-2 icon" />{" "}
                            Company Management
                          </NavLink>
                        </li>
                      )}
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/job-scheduled"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-calendar me-2 icon" /> Job
                          Schedule
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/chemicalcdslist"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-medkit me-2 icon" /> Health
                          & Safety
                        </NavLink>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}

            {/* Education Portal */}
            {selectedMenu === "education" &&
              (loginUserType === "SUPER_ADMIN" ||
                ((loginUserType === "ADMIN_MANAGER" ||
                  loginUserType === "CLEANING_MANAGER" ||
                  loginUserType === "CLIENT") &&
                  cleaningType === "College Cleaning")) && (
                <div className="dash-menu-bar">
                  <nav
                    className="nav-menu navbar navbar-expand-lg d-flex flex-column justify-content-center"
                    id="navbar"
                  >
                    <ul>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/education"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-th-large me-2 icon" />{" "}
                          Dashboard
                        </NavLink>
                      </li>
                      {loginUserType === "SUPER_ADMIN" && (
                        <li className="nav-item" onClick={addBodyClass}>
                          <NavLink
                            to="/education/edu-company-list"
                            className={({ isActive }) =>
                              isActive ? "nav-link active" : "nav-link"
                            }
                          >
                            <span className="fa fa-building me-2 icon" />{" "}
                            Company
                          </NavLink>
                        </li>
                      )}
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/education/edu-users-List"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-users me-2 icon" /> Users
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/education/college-list"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-university icon" /> College
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/education/block-list"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-building me-2 icon" /> Block
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/education/edu-report-management"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-list me-2 icon" /> Report
                          Management
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={addBodyClass}>
                        <NavLink
                          to="/education/edu-job-schedule"
                          className={({ isActive }) =>
                            isActive ? "nav-link active" : "nav-link"
                          }
                        >
                          <span className="fa fa-check-square me-2 icon" /> Job
                          Schedule
                        </NavLink>
                      </li>
                      {loginUserType !== "CLEANING_MANAGER" &&
                        loginUserType !== "CLIENT" && (
                          <li className="nav-item" onClick={addBodyClass}>
                            <NavLink
                              to="/education/chemicalcdslist"
                              className={({ isActive }) =>
                                isActive ? "nav-link active" : "nav-link"
                              }
                            >
                              <span className="fa fa-shield me-2 icon" /> Health
                              & Safety
                            </NavLink>
                          </li>
                        )}
                    </ul>
                  </nav>
                </div>
              )}
          </>
        )}
      </div>
    </>
  );
}
